import React from "react";

// Components
import BaseEntityCard from "~/components/cards/BaseEntityCard";
import SpecialistIcons from "~/components/icons/SpecialistIcons/SpecialistIcons";
// Type
import { AppointmentEntityType } from "~/utils/constants";
// Styles
import s from "~/components/cards/specialist/SpecialistCard.module.scss";
// Components
import { ISpecialistEntity } from "~/types/specialist";

interface Props {
  specialist: ISpecialistEntity;
  speciality: string;
  disabled?: boolean;
  onClick: (id: number) => void;
}

const SpecialistIcon: React.FC<Props> = ({ disabled }) => {
  return (
    <div className={s.specialistCardIconContainer}>
      <SpecialistIcons disabled={disabled} />
    </div>
  );
};

const SpecialistDescription: React.FC<Props> = ({ specialist, speciality }) => {
  return (
    <div className={s.specialistCardDescriptionContainer}>
      <h3 className={s.specialistCardName}>{specialist.lname}</h3>
      <p className={s.specialistCardSpeciality}>{speciality}</p>
    </div>
  );
};

const SpecialistCard: React.FC<Props> = ({ ...props }) => {
  return (
    <BaseEntityCard
      id={props.specialist.idDoctor}
      imageComponent={<SpecialistIcon {...props} />}
      descriptionComponent={<SpecialistDescription {...props} />}
      cardType={AppointmentEntityType.SPECIALIST}
      onClick={props.onClick}
    />
  );
};

export default SpecialistCard;
